import { render, staticRenderFns } from "./ModifyDocumentType.vue?vue&type=template&id=655b7c89&"
import script from "./ModifyDocumentType.vue?vue&type=script&lang=js&"
export * from "./ModifyDocumentType.vue?vue&type=script&lang=js&"
import style0 from "./ModifyDocumentType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports